import Vue from 'vue';

import OnlyChangedDocsFilter from 'components/product-sheets/filters/OnlyChangedDocsFilter.vue';
import MultiFilter from './MultiFilter.vue';
import SelectFilter from './SelectFilter.vue';
import BoolFilter from './BoolFilter.vue';
import CheckboxFilter from './CheckboxFilter.vue';
import RangeFilter from './RangeFilter.vue';
import IndustryFilter from './IndustryFilter.vue';
import ColorFilter from './ColorFilter.vue';
import OnlyNewFilter from './OnlyNewFilter.vue';
import ActiveFilterTag from './ActiveFilterTag.vue';

/**
 * Generic (functional) filter component.
 *
 * Acts as wrapper for the different filter types, so passing in a
 * filter key and it's config will render a new filter section including
 * the appropriate filter component (MultiFilter or BoolFilter at this time)
 */
export default Vue.component('filter-element', {
  functional: true,
  props: {
    config: {
      type: Object,
      required: true
    },
    filterCode: {
      type: String,
      required: true
    }
  },
  render(h, context) {
    const props = {
      filterKey: context.props.config.param,
      label: context.props.config.label
    };

    // Default to bool filter
    let child = BoolFilter;

    // Check if the config for a multi filter is given, update props
    if (context.props.config.type === 'multi') {
      props.options = context.props.config.options;
      child = MultiFilter;
    }

    if (context.props.config.type === 'select') {
      props.options = context.props.config.options;
      props.hideAllOption = context.props.config.hideAllOption;
      child = SelectFilter;
    }

    // Check for "boolean" type
    if (context.props.config.type === 'boolean') {
      props.value = context.props.config.selected;
    }

    // Check for "checkbox" type
    if (context.props.config.type === 'checkbox') {
      props.value = context.props.config.selected;
      props.disabled = context.props.config.disabled;
      child = CheckboxFilter;
    }

    // Check for "range" type
    if (context.props.config.type === 'range') {
      props.options = context.props.config.options;
      props.value = context.props.config.value;
      props.filterCode = context.props.filterCode;
      child = RangeFilter;
    }

    // Special component for the industry filter
    if (context.props.config.type === 'industry') {
      props.options = context.props.config.options;
      child = IndustryFilter;
    }

    if (context.props.config.type === 'color') {
      props.colors = context.props.config.options;
      child = ColorFilter;
    }

    // Special component for the "only changed docs" filter on the my sheets page
    if (context.props.config.type === 'onlyChangedDocs') {
      props.value = context.props.config.selected;
      child = OnlyChangedDocsFilter;
    }

    // Filter for "show only new" checkbox
    if (context.props.config.type === 'only_new') {
      props.minDate = context.props.config.minDate;
      props.disabled = context.props.config.disabled;
      props.legend = context.props.config.legend;
      child = OnlyNewFilter;
    }

    if (context.props.config.type === 'active_filter_tag') {
      child = ActiveFilterTag;
      props.value = context.props.config.value;
    }

    // Replace props, pass only the props relevant for the given child
    context.props = props;

    return h('div', {
      attrs: {
        class: context.data.staticClass
      }
    }, [
      h(child, context)
    ]);
  }
});
